var CalendarContainerCtrl = function ($scope,
                                      $rootScope,
                                      calendar,
                                      ModalService,
                                      SseService,
                                      resources,
                                      services,
                                      office,
                                      CalendarDA,
                                      CalendarSettings,
                                      $stateParams) {
  this.CalendarDA = CalendarDA;
  this.CalendarSettings = CalendarSettings;
  this.$stateParams = $stateParams;
  this.calendarModel = calendar;
  this.resources = resources;
  this.services = services;
  this.office = office;
  this._ModalService = ModalService;
  if (!calendar || !calendar.length || !calendar[0].resources || !calendar[0].resources.length) {
    this.noResourced = true;
  }

  var self = this;


  function handleSSE({data}) {
    try {
      data = JSON.parse(data);

      if (['appointment-updated', 'appointment-deleted', 'appointment-inserted'].includes(data.type)) {
        if (data.appointments?.length) {
          const calendarRange = self.getRange();
          const shouldReloadData = data.appointments.some((appointment) => {
            return moment(appointment.start).isBetween(calendarRange.start, calendarRange.end);
          });

          if (shouldReloadData) {
            self.loadCalendar();
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  SseService.notificationEventSource.addEventListener('message', handleSSE, false);

  const appointmentSavedListener = $rootScope.$on('appointmentSaved', () => {
    self.loadCalendar();
  });

  $scope.$on('$destroy', () => {
    appointmentSavedListener();
    SseService.notificationEventSource.removeEventListener('message', handleSSE, false);
  });
};

CalendarContainerCtrl.prototype.getRange = function () {
  let start;
  let end;

  if (this.calendarModel.length) {
    start = moment(this.calendarModel[0].date).startOf('day').toDate();
    end = moment(this.calendarModel[this.calendarModel.length - 1].date).endOf('day').toDate();
  }

  return {start, end};
};

CalendarContainerCtrl.prototype.loadCalendar = function () {
  this.CalendarDA
    .get(this.$stateParams)
    .then((response) => {
      let root = document.documentElement;
      const start = typeof response.min === 'number' ? response.min : 7;
      const end = typeof response.max === 'number' ? response.max : 23;
      const hours = end - start;
      root.style.setProperty('--hours', hours.toString());

      this.CalendarSettings.set('offset', response.min);
      this.CalendarSettings.set('end', response.max);
      this.calendarModel = response.dates;
    });
};


CalendarContainerCtrl.prototype.addAppointment = function () {
  const roundedUp = Math.ceil(moment().minute() / 5) * 5;
  const start = moment().minute(roundedUp).second(0).toDate();
  const appointment = {
    start: start,
    end: moment(start).add(30, 'minutes').toDate()
  };

  if (this.$stateParams.service) {
    appointment.services = [{
      _id: this.$stateParams.service,
      id: this.$stateParams.service
    }];
  }

  this._ModalService.openAppointmentModal(appointment);
};

module.exports = CalendarContainerCtrl;
